<script>
  import { DataInventoryServiceIdToName } from '../../../../shared/constants';
  export let row, entityType;
</script>

{#if entityType === 'data-feed-metadata'}
  {DataInventoryServiceIdToName[row.relatedEntityId]}
{:else}
  {row.relatedEntityId}
{/if}
